
import './App.scss';
import 'bootstrap/dist/css/bootstrap.min.css';

import {RanchSAT} from './RanchSAT';

function App() {

  return (


<div className="App">
<RanchSAT />

  </div>
  );
}

export default App;